import React, { Fragment, useState } from 'react';
import { Row, Col } from "reactstrap";
import { withNamespaces } from 'react-i18next';
import Nav from "../../components/Landing/Nav";
import Sponsor from "../../components/Landing/Sponsor";
import Contact from "../../components/Landing/Contact";
import Footer from "../../components/Landing/Footer";
import Menu from "../../components/Landing/Menu";
import SliderExpert from "../../components/Landing/SliderExpert";
import HowDoIt from "../../components/Landing/HowDoIt";
import Experience from "../../components/Landing/Experience";
import Faqs from "../../components/Landing/Faqs";

const LandingExpertos = (props) => {
    const[menu, setMenu] = useState(null);

    return (
        <Fragment>
            <Nav menu={ menu } setMenu={ setMenu }/>
            <Menu menu={ menu } setMenu={ setMenu } selectedMenu={ "experto" }/>
            <Row className="landing_profile_header">
                <Col xs={12} className="pt-3">
                    <HowDoIt type={ "experto" }/>
                </Col>
                <Col xs={12}>
                    <Experience type={ "experto" }/>
                </Col>
            </Row>
            <Row className="landing_profile_testimonials">
                <Col xs={12} className="text-center pt-5">
                    <p className="h1 testimonials_title">¡La fórmula sí funciona!</p>
                </Col>
                <Col xs={12} className="text-center pt-3 pb-5">
                    <Row>
                        <Col>
                            <SliderExpert />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="landing_profile_faq">
                <Col xs={12} className="pt-3">
                    <Faqs type={ "experto" }/>
                </Col>
            </Row>
            <Sponsor/>
            <Contact/>
            <Footer/>
        </Fragment>
    );
}

export default withNamespaces()(LandingExpertos);